export const regenDoseControllerLabelsId = {
  chemicalFlowId: "CHEMICAL_FLOW",
  dilutionFlowId: "DILUTION_WATER_FLOW",
  totalSolutionFlowId: "TOTAL_SOLUTION_FLOW",
  totalSolutionVolumeId: "TOTAL_SOLUTION_VOLUME",
  concentrationId: "CONCENTRATION",
  doseId: "DOSE",
  regenTimeId: "TIME",
  doseFractionId: "DOSE_FRACTION",
  regenerationRatioId: "REGENERATION_RATIO",
};
